module.exports = __webpack_public_path__ + "static/media/beach.10731f93.svg";